import { dispatchAction } from '@ardoq/rxbeach';
import { viewpointBuilderTracking } from '../viewpointBuilderTracking';
import {
  cancelEditPathCollapsingRule,
  clearCollapsedPathNodes,
  collapsingRuleIsActiveToggled,
  collapsingRuleToggled,
  createPathCollapsingRule,
  deletePathCollapsingRule,
  displayTextUpdated,
  editPathCollapsingRule,
  keepExpandedLevelsUpdated,
  graphNodeHovered,
  pathCollapsingNodeSelected,
  savePathCollapsingRule,
  setPathCollapsingRules,
} from './collapsePathsActions';
import { EditablePathCollapsingRule } from './types';
import { PathCollapsingRule } from '@ardoq/api-types';

export const getCollapsePathsCommands = (namespace: string) => ({
  createPathCollapsingRule: () =>
    dispatchAction(createPathCollapsingRule(), namespace),
  savePathCollapsingRule: (rule: EditablePathCollapsingRule) =>
    dispatchAction(savePathCollapsingRule(rule), namespace),
  deletePathCollapsingRule: (referenceTypeId: string) =>
    dispatchAction(deletePathCollapsingRule(referenceTypeId), namespace),
  editPathCollapsingRule: (referenceTypeId: string) =>
    dispatchAction(editPathCollapsingRule(referenceTypeId), namespace),
  cancelEditPathCollapsingRule: (rule: EditablePathCollapsingRule) =>
    dispatchAction(cancelEditPathCollapsingRule(rule), namespace),
  displayTextUpdated: (text: string) =>
    dispatchAction(displayTextUpdated(text), namespace),
  keepExpandedLevelsUpdated: (levels: number) =>
    dispatchAction(keepExpandedLevelsUpdated(levels), namespace),
  // naming here is a bit misleading. It's what's required in
  // viewpointBuilderEventListeners.ts, but we're actually not toggling anything,
  // just selecting a node.
  toggleIsSelectedGraphNode: (nodeId: string) => {
    viewpointBuilderTracking.trackComponentTypeNodeSelectedInGraph(
      'COLLAPSE_PATHS_TAB'
    );
    dispatchAction(pathCollapsingNodeSelected(nodeId), namespace);
  },
  setPathCollapsingRules: (rules: PathCollapsingRule[]) =>
    dispatchAction(setPathCollapsingRules(rules), namespace),
  clearCollapsedPathNodes: () =>
    dispatchAction(clearCollapsedPathNodes(), namespace),
  onGraphNodeHover: (nodeId: string | null) =>
    dispatchAction(graphNodeHovered(nodeId), namespace),
  collapsingRuleToggled: (referenceTypeId: string, isExpanded: boolean) =>
    dispatchAction(
      collapsingRuleToggled({ referenceTypeId, isExpanded }),
      namespace
    ),
  collapsingRuleIsActiveToggled: (referenceTypeId: string, isActive: boolean) =>
    dispatchAction(
      collapsingRuleIsActiveToggled({ referenceTypeId, isActive }),
      namespace
    ),
});

export type CollapsePathsCommands = ReturnType<typeof getCollapsePathsCommands>;
